import { PrepaidSettingsScreen } from '../modules/prepaid-balances/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanyPrepaidSettingsScreen() {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('prepaid_balances.settings.manage')}>
      <PrepaidSettingsScreen units={company.businessUnits ?? []} />
    </GatedCompanyScreen>
  );
}
